import React, { useEffect, useReducer, useState } from "react"
import { obterIndicacoesAmigos } from "../../../services/indicacoesAmigos"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { IndicacoesAmigosInicial } from "../models/indicacoesAmigosModel"
import { IndicacoesAmigosActionsTypes } from "./indicacoesAmigosActions"
import { IndicacoesAmigosContext } from "./IndicacoesAmigosContext"
import { indicacoesAmigosReducer } from "./indicacoesAmigosReducer"

export function IndicacoesAmigosContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(indicacoesAmigosReducer, IndicacoesAmigosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterIndicacoesAmigos(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar indicações")
            } else {
                setErroCarregamento(null)
                dispatch({ type: IndicacoesAmigosActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar indicações")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <IndicacoesAmigosContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </IndicacoesAmigosContext.Provider>
    )
}
